module.exports = __webpack_public_path__ + "img/home_06.0774b51b.png";